import { Outlet } from "react-router-dom";
import CRMHeader from "../../domain/crm/layout/CRMHeader";
import CRMLayout from "../../domain/crm/layout/CRMLayout";
import CRMSideTabs from "../../domain/crm/layout/CRMSideTabs";
import { useIsModuleEnabled } from "../../domain/platform_core/feature_flags/services/FeatureFlagService";
import ModuleLockedLayout from "../../domain/platform_core/funnel/components/ModuleLockedLayout";
import ServerUnavailable from "../../domain/platform_core/shell/components/ServerUnavailable";

export default function CRMPage() {
  const { isEnabled, isLoading, isError, isRetrying, retry } =
    useIsModuleEnabled("crm");

  // Keine CRM-Inhalte rendern, solange der Modulstatus nicht feststeht.
  if (isLoading) return null;
  if (isError) return <ServerUnavailable onRetry={retry} isRetrying={isRetrying} />;

  if (!isEnabled) {
    return (
      <ModuleLockedLayout
        moduleId="crm"
        moduleName="CRM"
        fallbackDescription="Maximiere deine Kundenbeziehungen"
      />
    );
  }

  return (
    <CRMLayout sidebar={<CRMSideTabs />} header={<CRMHeader />}>
      <Outlet />
    </CRMLayout>
  );
}
